import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import typography from "../tailwind-theme/typography";
import spacing from "../tailwind-theme/spacing";
import radius from "../tailwind-theme/radius";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: Object.keys(typography.fontSize) }],
      "font-family": [{ font: Object.keys(typography.fontFamily) }],
      "font-weight": [{ font: Object.keys(typography.fontWeight) }],
      p: [{ p: Object.keys(spacing) }],
      px: [{ px: Object.keys(spacing) }],
      py: [{ py: Object.keys(spacing) }],
      pt: [{ pt: Object.keys(spacing) }],
      pb: [{ pb: Object.keys(spacing) }],
      pl: [{ pl: Object.keys(spacing) }],
      pr: [{ pr: Object.keys(spacing) }],
      m: [{ m: Object.keys(spacing) }],
      mx: [{ mx: Object.keys(spacing) }],
      my: [{ my: Object.keys(spacing) }],
      mt: [{ mt: Object.keys(spacing) }],
      mb: [{ mb: Object.keys(spacing) }],
      ml: [{ ml: Object.keys(spacing) }],
      mr: [{ mr: Object.keys(spacing) }],
      h: [{ h: Object.keys(spacing) }],
      "space-x": [{ "space-x": Object.keys(spacing) }],
      "space-y": [{ "space-y": Object.keys(spacing) }],
      "space-x-reverse": [{ "space-x-reverse": Object.keys(spacing) }],
      "space-y-reverse": [{ "space-y-reverse": Object.keys(spacing) }],
      gap: [{ gap: Object.keys(spacing) }],
      "gap-x": [{ "gap-x": Object.keys(spacing) }],
      "gap-y": [{ "gap-y": Object.keys(spacing) }],
      rounded: [{ rounded: Object.keys(radius) }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
